const FilterFlyout = {
  parts: [
    'container',
    'header',
    'headerTop',
    'title',
    'clearButton',
    'content',
    'accordion',
    'accordionItem',
    'accordionButton',
    'accordionPanel',
    'categoryTitle',
    'appliedFiltersTitle',
    'arrowIcon',
    'appliedFiltersContainer',
    'filterPill',
    'filterPillText',
    'closeIcon',
    'option'
  ],
  baseStyle: {
    container: {
      display: 'flex',
      w: {base: 'full', md: '290px'},
      flex: {base: '0 0 100%', md: '0 0 290px'},
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 8, // 32px
      position: 'relative',
    },

    header: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 1.5, // 6px
      alignSelf: 'stretch',
      position: 'relative',
    },

    headerTop: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      alignSelf: 'stretch',
      position: 'relative',
    },

    title: {
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: '22px', // 22px
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
      letterSpacing: '-0.22px',
      position: 'relative',
    },

    clearButton: {
      color: 'brandColors.greyscale70',
      fontFamily: 'heading',
      fontSize: 'md', // 16px
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '120%',
      textDecoration: 'underline',
      bg: 'transparent',
      p: 0,
      minW: 'auto',
      h: 'auto',
      _hover: {
        bg: 'transparent',
        color: 'brandColors.greyscale90',
      },
    },

    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 30, // 120px
      alignSelf: 'stretch',
      position: 'relative',
    },

    accordion: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      border: 'none',
    },

    accordionItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      border: 'none',
      borderTop: '1px solid',
      borderColor: 'brandColors.greyscale10', // rgba(27, 26, 24, 0.10)
      sx: {
        ' .chakra-collapse': {
          w: 'full',
        },
      },
    },

    accordionButton: {
      display: 'flex',
      py: 6, // 24px
      px: 0,
      justifyContent: 'space-between',
      alignItems: 'center',
      alignSelf: 'stretch',
      position: 'relative',
      _hover: {
        bg: 'transparent',
      },
    },

    accordionPanel: {
      display: 'flex',
      pb: 6, // 24px
      px: 0,
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 2.5, // 10px
      position: 'relative',
    },

    categoryTitle: {
      color: 'black',
      fontFamily: 'heading',
      fontSize: {base: 'lg', md: 'lg'}, // 18px
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '160%',
      position: 'relative',
    },

    appliedFiltersTitle: {
      fontSize: 'xl',
      fontWeight: 'medium',
    },

    arrowIcon: {
      w: '13.333px',
      h: '13.333px',
      color: 'brandColors.primaryDarkLinen', // #8C683B
      transition: 'transform 0.2s',
      sx: {
        '[aria-expanded=true] &': {
          transform: 'rotate(180deg)',
        },
      },
    },

    appliedFiltersContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: 2.5, // 10px
      position: 'relative',
      w: 'full',
      flexWrap: 'wrap',
    },

    filterPill: {
      display: 'flex',
      p: '8px 16px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2, // 8px
      borderRadius: '100px',
      border: '1px solid',
      borderColor: 'brandColors.linen03', // #D6D2C5
      bg: 'transparent',
      position: 'relative',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      _hover: {
        bg: 'brandColors.secondaryBG',
        borderColor: 'brandColors.primaryDarkLinen',
      },
    },

    filterPillText: {
      color: 'brandColors.greyscale', // #1B1A18
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: 'md', // 16px
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '120%',
    },

    closeIcon: {
      w: 4, // 16px
      h: 4, // 16px
      color: '#32312F',
    },

    option: {
      color: 'black',
      fontFamily: 'heading',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '160%',
      cursor: 'pointer',
      _hover: {
        color: 'brandColors.primaryDarkLinen',
      },
    },
  },
};

export default FilterFlyout;
